<template>
  <button :disabled="loading" :class="{ 'btn-active': active }" class="btn relative text-center select-none" v-on="$listeners">
    <span class="btn-text w-full text-center" :class="{ 'opacity-0': loading }" style="transition: opacity 0.5s;">
      <!-- @slot Text in the button -->
      <slot />
    </span>
    <Transition name="fade">
      <div v-if="loading" class="absolute w-full left-0 top-center flex justify-center">
        <DrIcon svg="loading" class="animation-rotate" />
      </div>
    </Transition>
  </button>
</template>

<script>
export default {
  components: {},
  props: {
    loading: {
      type: [Boolean],
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.animation-rotate {
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>

<docs>
```vue
<DrButton>Test</DrButton>
```

### Button colors and variants are done via css classes:

- **colors**: `btn-cyan`, `btn-blue`, `btn-red`
- **sizes**: btn-sm, btn-lg
- **displays**: btn-outline

```vue
<DrButton class="btn-cyan">Test</DrButton>
<DrButton class="btn btn-cyan btn-outline">Test</DrButton>
<DrButton class="btn btn-cyan btn-sm">Test</DrButton>
<br />
<DrButton class="btn-blue">Test</DrButton>
<DrButton class="btn btn-blue btn-outline">Test</DrButton>
<DrButton class="btn btn-blue btn-sm">Test</DrButton>
<br />
<DrButton class="btn-red">Test</DrButton>
<DrButton class="btn btn-red btn-outline">Test</DrButton>
<DrButton class="btn btn-red btn-sm">Test</DrButton>

```

Loading state:
```vue
<DrButton class="btn btn-cyan" loading>Test</DrButton>
```
</docs>